import React, {useRef, useState} from "react";
import {useParams} from "react-router-dom";
import Select from "react-select";

import GenericTemplate from "../../../templates/GenericTemplate";

import {ApiResponse, ApolloAxios, getResultType, isSuccessApi} from "../../../atom/Apollo_ApiRequest3";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import {ApolloContext} from "../../../atom/Apollo_Context";
import {DataTableOptions, ApolloDataTable} from "../../../atom/Apollo_DataTable";
import {
  post_ms_ad_asset_batch_path,
  get_ms_ad_asset_batch_path,
  get_ms_ad_asset_batch_download_path
} from "../../../atom/Apollo_links";
import {ApolloMessage, CustomizedSnackbars} from "../../../atom/Apollo_Mesasge";
import {ApolloSingleFileSelect} from "../../../atom/Apollo_FileSelect2";
import {
  apollo_useStyles,
  options_batch_status,
  option_crasset_format_type
} from "../../../atom/Apollo_styles";
import {valueToLabel} from "../../../common/Apollo_CommonUtil";
import {
  ImmunityMessage,
} from "./common/AdAssetModel";

import moment from "moment";
import {MUIDataTableColumnDef, MUISortOptions, SelectableRows} from "mui-datatables";

import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card/Card";
import CardActions from "@material-ui/core/CardActions/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton"
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";

import {ApolloEventRecord, ItemList} from "../../../atom/Apollo_EventRecord";
import {RESULT_KBN} from "../../../common/Apollo_CommonConst";

const DATE_TIME_SUFFIX = "Z"
const BLANK = ""

/** Tab画面パーツ */
function a11yProps(index: any) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {children}
    </div>
  );
}

/**
 * base64をBlob(csv)に変換する
 * @param {string} base64 - base64文字列
 * @returns {Blob} base64をBlob(csv)に変換した値
 */
 const convertBlob = (base64: string): Blob => {
  var bin = atob(base64.replace(/^.*,/, ''));
  var buffer = new Uint8Array(bin.length);

  for (var i = 0; i < bin.length; i++) {
    buffer[i] = bin.charCodeAt(i);
  }

  return new Blob([buffer.buffer], {type: 'text/csv'});
}

/** 広告アセット一括処理アップロード */
const AdAssetCsvUploadMs: React.FC = () => {
  const classes = apollo_useStyles();
  const {data, setmsg} = React.useContext(ApolloMessage);
  const {state} = React.useContext(ApolloContext);
  const processing = useRef(false);
  const [isExistsProcess, setIsExistsProcess] = useState<boolean>(false);

  const {accountid, platformaccountid} = useParams<{
    accountid: string,
    platformaccountid: string
  }>()

interface UploadErrorRow {
  errorFile: string;
  errorDetail: string;
}

  const [tabstate, setTabstate] = useState(0);
  const [formatId, setFormatId] = useState(4);
  const [csvFile, setCsvFile] = useState("");
  const [imgZipFile, setImgZipFile] = useState("");
  const [table, setTable] = useState<[]>([]);
  const [uploadErrors, setUploadErrors] = useState<UploadErrorRow[]>([]);

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 19,
    breadId: 1,
    queries: [],
    menu: {
      id: 2,
      accountId: platformaccountid,
      accountName: "",
    },
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  React.useEffect(() => {
    getUploadedResultList();
  }, []);

  /** 入稿CSVアップロード結果一覧取得 */
  const getUploadedResultList = async () => {
    const queryParam
      = `?adAccountId=${platformaccountid}`
      + `&adAssetBatchId=0`
      + `&formatId=0`
      + `&perPage=100`
      + `&page=1`
      + `&sort=1`
      + `&direction=2`;
    const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_ad_asset_batch_path}${queryParam}`
    await ApolloAxios.get(url).then(response => {
      const res: ApiResponse = response.data;
      if (!isSuccessApi(res.resultCode)) {
        return Promise.reject({
          open: true,
          type: getResultType(res.resultCode),
          errmsg: `入稿CSVアップロード結果一覧の取得に失敗しました。${res?.message ?? ""}`,
        });
      }
      setTable(res.result);
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    }).finally(() => {
      //
    });
  }

  /** タブ切り替え */
  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabstate(newValue);
  };

  /** フォーマットタイプ変更 */
  const changeFormatType = (value: any) => {
    setFormatId(value.value);
  }

  /** テンプレートDL */
  const handleDownloadTemplete = () => {
    let fileName = "";
    switch (formatId) {
      case 4:
        fileName = "crasset_csv_template_single.csv";
        break;
      case 5:
        fileName = "crasset_csv_template_custom.csv";
        break;
      default:
        break;
    }
    let link = document.createElement('a');
    link.href = `/csv/ms/${fileName}`;
    link.download = `mail_${fileName}`;
    link.click();
  }

  /** アップロード */
  const handelSave = async () => {
    if (processing.current) return;
    processing.current = true;
    let isSuccess = false;
    let targetID = "";
    let targetName = "";

    if (csvFile === "") {
      processing.current = false;
      return setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "CSVファイルを設定してください。",
        }
      });
    }

    if (imgZipFile === "") {
      processing.current = false;
      return setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "画像ZIPファイルを設定してください。",
        }
      });
    }

    const params = new FormData();
    params.append('adAccountId', platformaccountid);
    params.append('formatId', String(formatId));
    params.append('batchCsv', csvFile[0]);
    params.append('imgZip', imgZipFile[0]);
    params.append('userId', String(state.userprofile.userId));

    // @ts-ignore
    const csvFileName = csvFile[0].name;
    // @ts-ignore
    const imgZipFileName = imgZipFile[0].name;

    let itemList: ItemList[] = [
      {
        key: "アップロードCSVファイル名",
        beforeValue: "",
        afterValue: csvFileName,
      },
      {
        key: "アップロードZIPファイル名",
        beforeValue: "",
        afterValue: imgZipFileName,
      },
    ]
    // 実行時
    ApolloEventRecord({
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: "execute",
      result: "",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken ,
      accountGroupID : state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID : state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "",
      displayName: "広告アセット一括アップロード(メール広告)画面",
      category: "広告アセット一括アップロード",
      actionType: "アップロード",
      targetID: "",
      targetName: "",
      itemList: itemList,
    });

    const url = `${process.env.REACT_APP_API_ENDPOINT}${post_ms_ad_asset_batch_path}`
    await ApolloAxios.post(
      url,
      params,
      {
        timeout: 60000 * 3,
        headers: {
          'Authorization': `Bearer ${state.accesstoken}`,
        }
      },
    ).then(response => {
      const res: ApiResponse = response.data;
      if (!isSuccessApi(res.resultCode)) {
        return Promise.reject({
          open: true,
          type: getResultType(res.resultCode),
          errmsg: `アップロードに失敗しました。${res?.message ?? ""}`,
        });
      }

      if(res.resultCode === RESULT_KBN.INFO) {
        setIsExistsProcess(true);
        setTimeout(() => {
          setIsExistsProcess(false);
        }, 10000);
        return Promise.reject({
          open: true,
          type: "warning",
          errmsg: res?.message,
        });
      }

      isSuccess = true;
      targetID = res.result;
      targetName = csvFileName + " " + imgZipFileName;
      setUploadErrors([])
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "info",
          message: `アップロードを受付けました。`,
        }
      });
    }).catch(err => {
      console.log(err);
      const apiRes = err?.error?.response?.data;

      if (
        apiRes &&
        apiRes.resultCode < 0 &&
        Array.isArray(apiRes.result)
      ) {
        setUploadErrors(
          apiRes.result.map((e: any) => ({
            errorFile: e.FileName,
            errorDetail: e.ErrorMsg,
          }))
        );
      } else {
        setUploadErrors([])
      }
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    }).finally(() => {
      // 実行結果
      ApolloEventRecord({
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        logType: "result",
        result: isSuccess? "成功" : "失敗",
        userID: state.userprofile.userId,
        userName: state.userprofile.userName,
        accessToken: state.accesstoken ,
        accountGroupID : state.current.accountGroupId,
        accountGroupName: state.current.accountGroupName,
        accountID : state.current.accountId,
        accountName: state.current.accountName,
        campaignID: "", // キャンペーンID
        campaignName: "", // キャンペーン名
        adGroupID: "", // 広告グループID
        adGroupName: "", // 広告グループ名
        menu: "",
        displayName: "広告アセット一括アップロード(メール広告)画面",
        category: "広告アセット一括アップロード",
        actionType: "アップロード",
        targetID: targetID,
        targetName: targetName,
        itemList: itemList,
      });

      processing.current = false;
    });

    if (isSuccess) {
      setCsvFile("");
      setImgZipFile("")
      await getUploadedResultList();
    }
  }

  /** 一覧.アップロード済み入稿CSV, アップロード済み入稿画像ZIP, エラーCSV */
  const downloadCsvZip = async (url: string) => {
    const baseUrl = url.replace(/\?.*$/, "");
    const link = document.createElement("a");
    link.href = baseUrl;
    link.click();
  }

  /** CSVダウンロード */
  const handleDownload = async () => {
    const queryParam
      = `?adAccountId=${platformaccountid}`
      + `&formatId=${formatId}`
      + `&adAssetId=0`;
    const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_ad_asset_batch_download_path}${queryParam}`
    await ApolloAxios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${state.accesstoken}`,
      }
    }).then(response => {
      const res: ApiResponse = response.data;
      if (!isSuccessApi(res.resultCode)) {
        return Promise.reject({
          open: true,
          type: getResultType(res.resultCode),
          errmsg: `CSVのダウンロードに失敗しました。${res?.message ?? ""}`,
        });
      }
      const csvFileName = `mail_${accountid}_${formatId}_${moment().format("YYYYMMDDHHmmss")}.csv`
      const blob = convertBlob(res.result);
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = csvFileName;
      link.click();
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    }).finally(() => {
      //
    });
  }

  const copyAllErrors = () => {
    const text = [
      "エラーファイル\tエラー詳細",
      ...uploadErrors.map(
        e => `${e.errorFile}\t${e.errorDetail}`
      )
    ].join("\n");

    navigator.clipboard.writeText(text).then(() => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "success",
          message: "エラー内容をクリップボードにコピーしました。",
        }
      });
    });
  };


  const columns: MUIDataTableColumnDef[] = [
    {
      name: "ad_asset_batch_id",
      label: "一括処理ID",
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "upload_date",
      label: "アップロード日時",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return value
            ? moment(value.replace(DATE_TIME_SUFFIX, BLANK)).format("YYYY-MM-DD HH:mm:ss")
            : BLANK;
        },
      }
    },
    {
      name: "upload_csv_file_name",
      label: "CSVファイル名",
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "batch_status",
      label: "ステータス",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return valueToLabel(value, options_batch_status);
        },
      }
    },
    {
      name: "all_number",
      label: "全件数",
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "success_number",
      label: "取り込み成功件数",
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "failed_number",
      label: "取り込みエラー件数",
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "upload_csv_file_url",
      label: "アップロード済み入稿CSV",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return (
            value
            ? <IconButton aria-label="download" onClick={() => downloadCsvZip(value)}>
              <CloudDownloadIcon/>
            </IconButton>
            : undefined
          );
        },
      }
    },
    {
      name: "upload_zip_file_url",
      label: "アップロード済み入稿画像ZIP",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return (
            value
            ? <IconButton aria-label="download" onClick={() => downloadCsvZip(value)}>
              <CloudDownloadIcon/>
            </IconButton>
            : undefined
          );
        },
      }
    },
    {
      name: "upload_err_csv_file_url",
      label: "エラーCSV",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return (
            value
            ? <IconButton aria-label="download" onClick={() => downloadCsvZip(value)}>
              <CloudDownloadIcon/>
            </IconButton>
            : undefined
          );
        },
      }
    },
  ]

  const errorColumns: MUIDataTableColumnDef[] = [
    {
      name: "errorFile",
      label: "エラーファイル",
      options: {
        sort: false,
        filter: false,
      },
    },
    {
      name: "errorDetail",
      label: "エラー詳細",
      options: {
        sort: false,
        filter: false,
      },
    },
  ];

  const errorTableOptions: DataTableOptions = {
    filter: false,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    selectableRows: "none",
    pagination: false,
    responsive: "standard",
    textLabels: {
      body: {
        noMatch: "エラーはありません",
      },
    },
  };

  const sortOrder: MUISortOptions = {
    name: "ad_asset_batch_id",
    direction: 'desc',
  }
  const selectableRows: SelectableRows = 'none';
  const options: DataTableOptions = {
    filter: false,
    download: false,
    print: false,
    search:false,
    sort: false,
    sortOrder: sortOrder,
    viewColumns:false,
    selectableRows: selectableRows,
    pagination:false,
    jumpToPage: false,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    textLabels:{
      body: {noMatch: "該当データが存在しません"}
    },
  }

  return (
    <GenericTemplate title="">
      <CustomizedSnackbars/>
      <ApolloBreadcrumbs2 data={breadcrumbsData}/>

      <Tabs value={tabstate} onChange={handleTabChange} aria-label="creative tabs">
        <Tab label="アップロード" {...a11yProps(0)} />
        <Tab label="入稿CSVアップロード結果一覧" {...a11yProps(1)} />
        <Tab label="入稿CSVダウンロード" {...a11yProps(2)} />
      </Tabs>
      <TabPanel value={tabstate} index={0}>
        <Card className={classes.root} square variant="outlined">
          <CardContent>
            <Typography variant="subtitle1" gutterBottom component="div">
              フォーマットタイプ
            </Typography>
            <Select
              closeMenuOnSelect={true}
              options={option_crasset_format_type}
              onChange={changeFormatType}
              defaultValue={option_crasset_format_type[0]}
              value={option_crasset_format_type.find(option => option.value === formatId)}
            />
          </CardContent>
          <CardContent>
            <Grid container>
              <Grid item xs={6}>
                <Typography variant="subtitle1" gutterBottom component="div">
                  アップロードCSVファイル{formatId === 4 ? "（シングル画像）" : formatId === 5 ? "（カスタム画像）" : ""}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="button" gutterBottom component="div" align="right">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDownloadTemplete}
                    className={classes.button}
                  >
                    テンプレートDL
                  </Button>
                </Typography>
              </Grid>
            </Grid>
            <ApolloSingleFileSelect
              fileState={{
                file: csvFile,
                setFile: setCsvFile,
              }}
              accept={".csv"}
            ></ApolloSingleFileSelect>
          </CardContent>
          <CardContent>
            <Typography variant="subtitle1" gutterBottom component="div">
              アップロードZIPファイル{formatId === 4 ? "（シングル画像）" : formatId === 5 ? "（カスタム画像）" : ""}
            </Typography>
            <ApolloSingleFileSelect
              fileState={{
                file: imgZipFile,
                setFile: setImgZipFile,
              }}
              accept={".zip"}
              maxSize={20}
            ></ApolloSingleFileSelect>
          </CardContent>
          <Grid style={{marginTop:"45px"}}>
            {
              ImmunityMessage
                ? ImmunityMessage.map((msg: string) =>
                  <p style={{margin: "0", marginLeft: "20px", padding: "3px", color: "#595757"}}>{msg}</p>
                )
                : undefined
            }
          </Grid>
          <CardActions className={classes.cardaction}>
            <Button
              variant="contained"
              color="primary"
              onClick={handelSave}
              className={classes.button}
              disabled={isExistsProcess}
            >
              アップロード
            </Button>
          </CardActions>
          {uploadErrors.length > 0 && (
           <CardContent>
             <Typography variant="subtitle1" gutterBottom>
               アップロードエラー一覧
             </Typography>
              
             <ApolloDataTable
               title={""}
               data={uploadErrors}
               columns={errorColumns}
               options={errorTableOptions}
             />
               
             <div style={{ marginTop: "16px", textAlign: "right" }}>
               <Button
                 variant="contained"
                 color="primary"
                 onClick={copyAllErrors}
               >
                 すべてクリップボードにコピー
               </Button>
             </div>
           </CardContent>
         )}
        </Card>
      </TabPanel>
      <TabPanel value={tabstate} index={1}>
        <Card className={classes.root} square variant="outlined">
          <ApolloDataTable
            data={table}
            columns={columns}
            options={options}
            title=""
          />
        </Card>
      </TabPanel>
      <TabPanel value={tabstate} index={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12}>
            <Card className={classes.root} square variant="outlined">
              <CardContent>
                <Typography variant="subtitle1" gutterBottom component="div">
                  フォーマットタイプ
                </Typography>
                <Select
                  closeMenuOnSelect={true}
                  options={option_crasset_format_type}
                  onChange={changeFormatType}
                  defaultValue={option_crasset_format_type[0]}
                  value={option_crasset_format_type.find(option => option.value === formatId)}
                />
              </CardContent>
              <CardActions className={classes.cardaction}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleDownload}
                  className={classes.button}
                >
                  CSVダウンロード
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </TabPanel>
    </GenericTemplate>
  )
};
export default AdAssetCsvUploadMs;
